import { cx } from "@emotion/css";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import LekIcon from "src/images/Icons/lekIcon.svg";
import PesIcon from "src/images/Icons/pesIcon.svg";

const ServiceBox = (props) => {
	return (
		<div className="service-box" onClick={props.onClick} data-test-id={props.testId}>
			<div className={cx("grey-square", props.iconClassName)}>{props.Icon}</div>
			<div className="flex flex-col items-start gap-4">
				<h4 className="size-20 m-0">{props.name}</h4>
				<span className="size-16-tiny">{props.description}</span>
			</div>
		</div>
	);
};

const BasicService = styled((props) => {
	const { t } = useTranslation();

	return (
		<ServiceBox
			onClick={() => props.onChange("lek")}
			Icon={<LekIcon className="icon-big icon-primary" />}
			name={t("auth.services.lek.name")}
			description={t("auth.services.lek.description")}
			className={props.className}
			testId="service-box-lek"
		/>
	);
})``;

const PesService = styled((props) => {
	const { t } = useTranslation();

	return (
		<ServiceBox
			onClick={() => props.onChange("pes")}
			Icon={<PesIcon className="icon-big icon-primary-orange" />}
			name={t("auth.services.pes.name")}
			description={t("auth.services.pes.description")}
			secondary
			className={props.className}
			testId="service-box-pes"
		/>
	);
})``;

const ServiceBoxes = (props) => {
	return (
		<div className="flex flex-col gap-16 w-100">
			<BasicService onChange={props.onChange} />
			<PesService onChange={props.onChange} />
		</div>
	);
};

export default ServiceBoxes;
